<div class="info-box-container">
    <div class="info-box">
        <p class="info-text">
            <em>
                This AI analysis indicates whether your uploaded files address the task requirements
                and is ready for evaluation. It does not indicate if requirements have been met, only
                that a response has been provided – an evaluator will assess your task submission to
                determine if competence has been achieved. The analysis excludes images and unsupported
                file types (indicated by a
                <mat-icon class="inline-icon" svgIcon="document_partially_unprocessed"></mat-icon> icon–mouse over files for explanation).
            </em>
        </p>

        <div class="expanded-content" [class.visible]="isExpanded">
            <p class="expanded-title"><em><strong>AI Analysis Overview</strong></em></p>

            <div class="expanded-details">
                <p><em>
                    WGU is committed to the transparent and ethical use of AI in learning environments.
                    Our goal is to ensure student success, protect privacy, and maintain fairness in all
                    evaluations. All files and content reviewed by this tool are used only for improvement
                    of your learning experience. They are not used to train AI models.
                </em></p>

                <p><em>This analysis currently supports text-based elements of the following file types:</em></p>

                <ul class="file-types">
                    <li><em>.docx</em></li>
                    <li><em>.doc</em></li>
                    <li><em>.txt</em></li>
                    <li><em>.pdf</em></li>
                    <li><em>.rtf</em></li>
                    <li><em>.odt</em></li>
                </ul>

                <p><em>
                    File types not on the above list and/or that include non-textual elements (such as images, video, etc.)
                    may not be included in the AI analysis. If your submission includes such files or elements, verify
                    that flagged requirements have been included in your files before submitting them for evaluation.
                    If your submission includes corrupted or encrypted filed, they will not be included in the AI analysis.
                </em></p>

                <p><em>
                    See <a href="https://cm.wgu.edu/t5/Frequently-Asked-Questions/Assessment-Submissions-AI-Completeness-Check/ta-p/844" target="_blank" rel="noopener noreferrer">this article</a> for more information.
                </em></p>
            </div>
        </div>

        <button class="expand-button" (click)="toggleExpand()">
            <mat-icon>{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            <span>SEE MORE INFORMATION</span>
        </button>
    </div>
</div>